import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
var withRightAnimatedIconStyles = css(["span,svg{vertical-align:middle;}svg{position:relative;left:0;transition:left 0.3s ease;}span + svg{margin-left:4px;}&:not([disabled]):hover{svg{left:6px;}}"]);
var smallStyles = css(["padding:6px 12px;", ";"], getFont(-1, 'compact'));
var mediumStyles = css(["padding:6px 18px;", ";"], getFont(0));
var defaultStyles = css(["padding:9px 24px;", ";"], getFont(0));
var largeStyles = css(["padding:12px 30px;", ";"], getFont(1));
var getButtonStyles = function getButtonStyles(variant) {
  switch (variant) {
    case 'small':
      return smallStyles;
    case 'medium':
      return mediumStyles;
    case 'large':
      return largeStyles;
    default:
      return defaultStyles;
  }
};
export var Button = styled.button.attrs(function (props) {
  return {
    variant: undefined,
    $variant: props.variant,
    $width: props.width,
    width: undefined,
    role: 'button'
  };
}).withConfig({
  displayName: "Button",
  componentId: "sc-reuwjs-0"
})(["user-select:none;display:inline-block;", ";width:", ";max-width:", ";border-radius:4px;cursor:pointer;background-color:", ";font-family:", ";font-weight:600;white-space:nowrap;color:", ";", ";text-align:center;transition:background-color 0.15s;", " &:not([disabled]):hover:focus:active{box-shadow:0 0 8px 3px ", ";background-color:", ";}&[disabled]{cursor:not-allowed;background-color:", ";color:", ";}&:not([disabled]):hover{background-color:", ";}"], function (_ref) {
  var $variant = _ref.$variant;
  return getButtonStyles($variant);
}, function (_ref2) {
  var $width = _ref2.$width;
  return $width === 'auto' ? 'auto' : '100%';
}, function (_ref3) {
  var $width = _ref3.$width;
  return $width && $width !== 'auto' && $width;
}, function (_ref4) {
  var theme = _ref4.theme,
    secondary = _ref4.secondary,
    color = _ref4.color;
  return secondary || color === 'secondary' ? theme.secondaryButtonColor : theme.buttonColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.bodyFontFamily;
}, function (_ref6) {
  var theme = _ref6.theme,
    secondary = _ref6.secondary,
    color = _ref6.color;
  return secondary || color === 'secondary' ? theme.secondaryButtonFontColor : theme.buttonFontColor;
}, fontSmoothing, function (_ref7) {
  var _ref7$withRightAnimat = _ref7.withRightAnimatedIcon,
    withRightAnimatedIcon = _ref7$withRightAnimat === void 0 ? false : _ref7$withRightAnimat;
  return withRightAnimatedIcon ? withRightAnimatedIconStyles : '';
}, function (_ref8) {
  var theme = _ref8.theme,
    secondary = _ref8.secondary,
    color = _ref8.color;
  return secondary || color === 'secondary' ? theme.secondaryButtonFocusShadowColor : theme.buttonFocusShadowColor;
}, function (_ref9) {
  var theme = _ref9.theme,
    secondary = _ref9.secondary,
    color = _ref9.color;
  return secondary || color === 'secondary' ? theme.secondaryButtonFocusActiveColor : theme.buttonFocusActiveColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.uiL;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.fontLL;
}, function (_ref12) {
  var theme = _ref12.theme,
    secondary = _ref12.secondary,
    color = _ref12.color;
  return secondary || color === 'secondary' ? theme.secondaryButtonHoverColor : theme.buttonHoverColor;
});